import { Column } from '~components/table-view-v3';

const columnsList: Column[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
  },
  {
    id: 'date_start',
    header: 'Start Date',
    type: 'date',
  },
  {
    id: 'date_end',
    header: 'End Date',
    type: 'date',
    deriveValue: (row) => row.date_end ?? 'Not Set',
  },
];

export default columnsList;
